<template>
  <div id="projectDetails">
    <Header></Header>
    <img class="img" :src=this.$route.query.detailsSrc width="60%">
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/header/Header";
import Footer from "@/components/footer/Footer";
export default {
  name: "aboutUs",
  components:{
    Footer,
    Header
  },
  data(){
    return {
      imgSrc:''
    }
  }

}
</script>

<style scoped>
#projectDetails{
  width: 100%;
  height: auto;
}
.img{
  text-align: center;
  margin: 0 auto;
}

</style>

